var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raffle-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v2---raffle-main",
    transform: "translate(-1320.000000, -393.000000)",
    fill: "#0176B5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-icons",
    transform: "translate(1304.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-whatsapp-4-copy",
    transform: "translate(0.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,32 C18.627417,32 24,37.372583 24,44 C24,50.627417 18.627417,56 12,56 C5.372583,56 0,50.627417 0,44 C0,37.372583 5.372583,32 12,32 Z M17.5999998,38 L6.39999998,38 C5.62299999,38 5,38.623 5,39.4 L5,47.7999998 C5,48.5731985 5.62680134,49.1999998 6.39999998,49.1999998 L17.5999998,49.1999998 C18.3731984,49.1999998 19,48.5731985 19,47.7999998 L19,39.4 C19,38.623 18.3699998,38 17.5999998,38 Z M17.5999998,39.4 L17.5999998,40.8 L11.9999999,44.2999999 L6.39999998,40.8 L6.39999998,39.4 L11.9999999,42.9 L17.5999998,39.4 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.a0d35ee312b6ce694c9e6cf8a80bd52d.svg";
export { ForwardRef as ReactComponent };